import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Belum dynamic TODO
 * @param {*} param0
 * @returns
 */
export default function Modal({ open = false, close = () => {} }) {
  const navigate = useNavigate();
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={close}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md md:max-w-lg xl:max-w-lg transform overflow-hidden rounded-xl border border-primaryGreen bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                  Dashboard Pembangunan
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-700">
                    Untuk mengakses halaman detail silahkan login terlebih dahulu....
                  </p>
                </div>

                <div className="mt-4 flex justify-between gap-5">
                  <button
                    type="button"
                    className=" w-full rounded-md border border-transparent bg-primaryOrange px-4 py-2 text-sm font-bold text-white "
                    onClick={close}
                  >
                    Batal
                  </button>
                  <button
                    type="button"
                    className=" w-full rounded-md border border-transparent bg-primaryGreen px-4 py-2 text-sm font-bold text-white "
                    onClick={() => navigate('/login')}
                  >
                    Login
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
